export default __webpack_public_path__ + "static/media/ic-chat.44e0c338.svg";